<div class="main-container">
  <div class="search-input">
    <ion-icon name="search-outline"></ion-icon>
    <input
      (input)="onInputChange($event.target.value)"
      [(ngModel)]="searchText"
      class="input"
      placeholder="Search"
      autocapitalize="off"
      autocorrect="off"
      spellcheck="false"
    />
    <ion-icon slot="end" (click)="clearSearch()" name="close-circle"></ion-icon>
  </div>

  <div *ngIf="displayName" class="selected-agent-text">
    {{displayName}} is the primary agent assigned to this listing
    <span class="link" (click)="clickInfoText()">
      <ion-icon
        slot="icon-only"
        name="information-circle"
        class="link noTooltip"
      ></ion-icon>
    </span>
  </div>

  <div *ngIf="hits.length !== 0" class="hits">
    <div class="hit" *ngFor="let hit of hits">
      <!-- 
      `childComponent` is used to render the passed in component. `context` defines the available variables to be binded
      using the `let-...` syntax. Using the `$implicit` token set the default value to be binded, in this case, the current hit
    -->
      <ng-container
        *ngTemplateOutlet="childComponent; context: { $implicit: hit }"
      ></ng-container>
    </div>
  </div>

  <div *ngIf="displayNoResultsLabel()" class="no-results-label">
    {{ noResultsMessage }}
  </div>
</div>
